import { useMemo } from 'react';

import { CollectionsV1ResourceType } from '@spotify/confidence-graphql';

import { useCollectionResourceNames } from '../useCollectionResourceNames';

export const useCollectionResourcesFilter = (
  collectionName: string | null,
  options?: { resourceType?: CollectionsV1ResourceType },
): { nameFilter: string; loading: boolean } => {
  const { resourceNames, loading } = useCollectionResourceNames(
    collectionName,
    options,
  );

  const nameFilter = useMemo(() => {
    if (!collectionName || loading || resourceNames.size === 0) return '';
    return `(${[...resourceNames].map(n => `name:"${n}"`).join(' OR ')})`;
  }, [collectionName, loading, resourceNames]);

  return { nameFilter, loading };
};
